// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w_NY","left":"styles_left__EXLCc"};